import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { DownloadOutlined, FilterOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Select, Button, Drawer, Switch, Input } from 'antd';
import moment from 'moment';
import {
	changeFilterValueToArrayOfIds,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import {
	locationsRestCrudThunksForBuyer,
	locationsRestCrudThunksForSupplier,
} from '../../thunks/locations_thunks';
import {
	fetchSupplierFacilitiesIfEverInPrivateNetworkForBuyer,
	fetchSupplierFacilitiesIfEverInPrivateNetworkForSupplier,
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from '../../thunks/supplier_facilities_thunks';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import BuyerRegionsLocationsTreeSelect from '../regions_tree_select/RegionsLocationsTreeSelect';
import AnalyticsSelectedFilters from './AnalyticsSelectedFilters';
import { getDefaultDateRanges, stringArrToList } from '../../utils/DataFormatterUtils';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import { FILTER_FIELD_TYPE, ROLE_TYPES } from '../../utils/DataConstants';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesHeirarchicalForSupplier,
} from '../../thunks/problem_types_thunks';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import { BUYER_ADMIN, SUPER_ADMIN } from '../roles/roles';
import OWDatePicker from '../ow_date_picker/OWDatePicker';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesRestCrudThunksForSupplier,
} from '../../thunks/work_order_priorities_thunks';
require('./AnalyticsControlBar.less');

interface AnalyticsControlBarFormProps extends FormComponentProps {
	startDate: any;
	endDate: any;
	workCreatedAtStartDate: any;
	workCreatedAtEndDate: any;
	workCompletedAtStartDate: any;
	workCompletedAtEndDate: any;
	locationIds: any;
	supplierFacilityIds: any;
	isCapex: any;
	isPM: any;
	updateFilters: any;
	supplierFacilities: any;
	fetchMultipleLocations: any;
	fetchLocations: any;
	fetchMultipleSupplierFacilities: any;
	fetchSupplierFacilitiesIfEverInPrivateNetwork: any;
	hideLocationsControl: any;
	locations: any;
	problemTypes: any;
	problemTypeIds: any;
	fetchProblemTypes: any;
	brandIds: any;
	fetchBrandsCount: any;
	brands: any;
	fetchBrands: any;
	fetchMultipleBrands: any;
	showSearch?: boolean;
	showDownload: boolean;
	onSearch?: any;
	search?: any;
	filterConfig: any;
	onDownload: any;
	currentUser: any;
	hideSuppliersControl: any;
	dateRangeLabel: any;
	searchPlaceholder: any;
	woPriorityIds: any;
	fetchWorkOrderPriorities: any;
	workOrderPriorities: any;

	state: any;
}

class AnalyticsControlBar extends React.Component<AnalyticsControlBarFormProps, any> {
	state = {
		editing: false,
		allowLocationEdit: false,
		allowSupplierEdit: false,
		brandAvailable: false,
	};

	getFilterValues = () => {
		const {
			startDate,
			endDate,
			workCreatedAtStartDate,
			workCreatedAtEndDate,
			workCompletedAtStartDate,
			workCompletedAtEndDate,
			locationIds,
			supplierFacilityIds,
			isCapex,
			isPM,
			problemTypeIds,
			woPriorityIds,
			brandIds,
		} = this.props;
		return {
			problemTypeIds:
				(problemTypeIds && changeFilterValueToArrayOfIds(problemTypeIds)) || undefined,
			woPriorityIds: (woPriorityIds && changeFilterValueToArrayOfIds(woPriorityIds)) || undefined,
			brandIds: (brandIds && changeFilterValueToArrayOfIds(brandIds)) || undefined,
			startDate: startDate || moment().subtract(6, 'months'),
			endDate: endDate || moment(),
			workCreatedAtStartDate,
			workCreatedAtEndDate,
			workCompletedAtStartDate,
			workCompletedAtEndDate,
			locationIds,
			supplierFacilityIds,
			isCapex,
			isPM,
		};
	};

	checkBrandsCount = () => {
		const { fetchBrandsCount } = this.props;
		fetchBrandsCount().then((count) =>
			this.setState({
				brandAvailable: count > 0,
			})
		);
	};

	componentDidMount() {
		const { startDate, endDate, updateFilters } = this.props;

		if (!startDate || !endDate) {
			updateFilters(this.getFilterValues());
		}

		this.checkBrandsCount();
	}

	handleSubmit = (e) => {
		const { updateFilters } = this.props;
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const newFilters = {
					locationIds: values.selectAllLocations ? undefined : values.locationIds.sort(),
					supplierFacilityIds: values.selectAllSuppliers
						? undefined
						: nullSafeGetOrElse('supplierFacilityIds', values, []).sort(),
					problemTypeIds: (values.problemTypeIds && values.problemTypeIds.join(',')) || undefined,
					woPriorityIds: (values.woPriorityIds && values.woPriorityIds.join(',')) || undefined,
					brandIds: (values.brandIds && values.brandIds.join(',')) || undefined,
					startDate: nullSafeGet('startAndEndDates.0', values),
					endDate: nullSafeGet('startAndEndDates.1', values),
					workCreatedAtStartDate: nullSafeGet('workCreatedBetweenStartAndEndDates.0', values),
					workCreatedAtEndDate: nullSafeGet('workCreatedBetweenStartAndEndDates.1', values),
					workCompletedAtStartDate: nullSafeGet('workCompletedBetweenStartAndEndDates.0', values),
					workCompletedAtEndDate: nullSafeGet('workCompletedBetweenStartAndEndDates.1', values),
					isCapex: values.isCapex,
					isPM: values.isPM,
				};
				updateFilters(newFilters);
				this.setState({ editing: false });
			}
		});
	};

	handleCancel = (e) => {
		e.preventDefault();
		this.props.form.resetFields();
		this.setState({ editing: false });
	};

	updateFiltersFromDisplay = (updatedFilter) => {
		const { updateFilters } = this.props;
		updateFilters({ ...this.getFilterValues(), ...updatedFilter });
	};

	getLocationsString(locationIds = [], locations) {
		const locationNames = locationIds.map((id) => nullSafeGet(`${id}.name`, locations.records));
		if (locationIds.length === 0) {
			return 'no locations';
		} else if (locationIds.length > 0 && locationIds.length < 3) {
			return stringArrToList(locationNames);
		} else {
			return `${locationIds.length} locations`;
		}
	}

	getSupplierFacilitiesString(supplierFacilityIds = [], supplierFacilities) {
		const supplierFacilityNames = supplierFacilityIds.map((id) =>
			nullSafeGet(`${id}.displayName`, supplierFacilities.records)
		);
		if (supplierFacilityIds.length === 0) {
			return 'no suppliers';
		} else if (supplierFacilityIds.length > 0 && supplierFacilityIds.length < 3) {
			return stringArrToList(supplierFacilityNames);
		} else {
			return `${supplierFacilityIds.length} suppliers`;
		}
	}

	handleAllLocationsChange = (value) => {
		this.setState({ allowLocationEdit: !value });
	};

	handleAllSuppliersChange = (value) => {
		this.setState({ allowSupplierEdit: !value });
	};

	openDrawer = () => this.setState({ editing: true });

	render() {
		const {
			startDate,
			endDate,
			workCreatedAtStartDate,
			workCreatedAtEndDate,
			workCompletedAtStartDate,
			workCompletedAtEndDate,
			locationIds,
			isCapex,
			isPM,
			form,
			supplierFacilities,
			fetchMultipleSupplierFacilities,
			fetchSupplierFacilitiesIfEverInPrivateNetwork,
			supplierFacilityIds,
			hideLocationsControl,
			locations,
			problemTypes,
			problemTypeIds,
			fetchProblemTypes,
			woPriorityIds,
			workOrderPriorities,
			fetchWorkOrderPriorities,
			brandIds,
			brands,
			fetchBrands,
			fetchMultipleBrands,
			showSearch,
			showDownload,
			onSearch,
			search,
			filterConfig,
			onDownload,
			currentUser,
			hideSuppliersControl,
			dateRangeLabel,
			searchPlaceholder,
			state,
		} = this.props;
		const { editing } = this.state;
		const RANGE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';
		const dateRangeLabelString =
			dateRangeLabel ||
			(nullSafeGet('isSpendAnalytics', filterConfig)
				? 'Invoice Received Between'
				: 'Work Created Between');

		const capExFieldItems = [
			{
				label: 'All',
				value: undefined,
			},
			{
				label: 'R&M',
				value: 'false',
			},
			{
				label: 'CapEx',
				value: 'true',
			},
		];

		const plannedFieldItems = [
			{
				label: 'All',
				value: undefined,
			},
			{
				label: 'Planned',
				value: 'true',
			},
			{
				label: 'Reactive',
				value: 'false',
			},
		];

		const isAdmin =
			currentUser.roles.includes(BUYER_ADMIN) || currentUser.roles.includes(SUPER_ADMIN);
		const hasAccessToAllLocations = nullSafeGet('hasAccessToAllLocations', currentUser) || isAdmin;
		const FilterControls = (
			<Form
				layout="vertical"
				hideRequiredMark={true}
				style={{ maxWidth: 800 }}
				onSubmit={this.handleSubmit}
			>
				<h5>Filters</h5>
				<Form.Item label={dateRangeLabelString}>
					{form.getFieldDecorator('startAndEndDates', {
						rules: [
							{
								type: 'array',
								required: true,
								message: 'Please select a start and end date!',
							},
						],
						initialValue: startDate && endDate ? [moment(startDate), moment(endDate)] : undefined,
					})(
						<OWDatePicker
							key={
								startDate && endDate
									? startDate.format('YYMMDD') + endDate.format('YYMMDD')
									: undefined
							}
							ranges={getDefaultDateRanges()}
							format={RANGE_PICKER_DATE_FORMAT}
							showTime={false}
						/>
					)}
				</Form.Item>
				{hideLocationsControl ? null : (
					<>
						<Form.Item style={{ marginBottom: '0px' }} label="Locations">
							{form.getFieldDecorator('selectAllLocations', {
								initialValue: !this.state.allowLocationEdit,
								valuePropName: 'checked',
							})(<Switch onChange={this.handleAllLocationsChange} />)}
							<label style={{ marginLeft: 8 }}>
								Select {hasAccessToAllLocations ? 'All Locations' : 'All Assigned Locations'}
							</label>
						</Form.Item>
						<Form.Item>
							{form.getFieldDecorator('locationIds', {
								initialValue: this.state.allowLocationEdit ? locationIds : [],
							})(
								<BuyerRegionsLocationsTreeSelect
									mode="multiple"
									disabled={!this.state.allowLocationEdit}
									filtersSlice={locations}
									filtersValueAccessor={() => form.getFieldValue('locationIds')}
									targetCollectionName={'locationsAnalyticsDropdown'}
								/>
							)}
						</Form.Item>
					</>
				)}
				{hideSuppliersControl ? null : (
					<>
						<Form.Item style={{ marginBottom: '0px' }} label="Suppliers">
							{form.getFieldDecorator('selectAllSuppliers', {
								initialValue: !this.state.allowSupplierEdit,
								valuePropName: 'checked',
							})(<Switch onChange={this.handleAllSuppliersChange} />)}
							<label style={{ marginLeft: 8 }}>Select All Suppliers</label>
						</Form.Item>
						<Form.Item>
							{form.getFieldDecorator('supplierFacilityIds', {
								initialValue: this.state.allowSupplierEdit ? supplierFacilityIds : [],
							})(
								<OWAsyncTreeSelect
									allowClear={true}
									mode="multiple"
									disabled={!this.state.allowSupplierEdit}
									stateSlice={supplierFacilities}
									targetCollectionName="supplierFacilitiesAnalyticsDropdown"
									fetchData={(
										searchText,
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									) =>
										fetchSupplierFacilitiesIfEverInPrivateNetwork(
											{ name: searchText },
											targetCollectionName,
											pagination,
											sorting,
											filters,
											addToTargetCollection
										)
									}
									fetchMultiple={(ids, targetCollectionName) => {
										fetchMultipleSupplierFacilities(ids, targetCollectionName);
									}}
									renderRecord={(sf) => (
										<Select.Option key={sf.id} value={sf.id}>
											{sf.name}
										</Select.Option>
									)}
								/>
							)}
						</Form.Item>
					</>
				)}
				{nullSafeGet('problemTypes', filterConfig) && (
					<Form.Item label="Problem Types">
						{form.getFieldDecorator('problemTypeIds', {
							initialValue: changeFilterValueToArrayOfIds(problemTypeIds),
						})(
							<ProblemTypeTreeSelect
								allowClear={true}
								mode="multiple"
								stateSlice={problemTypes}
								targetCollectionName="analyticsProblemTypesDropDown"
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) =>
									fetchProblemTypes(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									)
								}
								fetchMultiple={() => {}}
								renderRecord={(pt) => (
									<Select.Option key={pt.id} value={pt.id}>
										{pt.name}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				)}
				{nullSafeGet('workOrderPriorities', filterConfig) && (
					<Form.Item label="Work Order Priorities">
						{form.getFieldDecorator('woPriorityIds', {
							initialValue: changeFilterValueToArrayOfIds(woPriorityIds),
						})(
							<OWAsyncSelect
								allowClear={true}
								mode="multiple"
								stateSlice={workOrderPriorities}
								targetCollectionName="analyticsWorkOrderPrioritiesDropDown"
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) =>
									fetchWorkOrderPriorities(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									)
								}
								fetchMultiple={() => {}}
								renderRecord={(pt) => (
									<Select.Option key={pt.id} value={pt.id}>
										{pt.name}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				)}
				{this.state.brandAvailable && (
					<Form.Item label="Brands">
						{form.getFieldDecorator('brandIds', {
							initialValue: changeFilterValueToArrayOfIds(brandIds),
						})(
							<OWAsyncSelect
								allowClear={true}
								mode="multiple"
								stateSlice={brands}
								targetCollectionName="analyticsAdvancedFilters"
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) =>
									fetchBrands(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									)
								}
								fetchMultiple={(ids, targetCollectionName) => {
									fetchMultipleBrands(ids, targetCollectionName);
								}}
								renderRecord={(b) => (
									<Select.Option key={b.id} value={b.id}>
										{b.brandName}
									</Select.Option>
								)}
							/>
						)}
					</Form.Item>
				)}
				{nullSafeGet('capEx', filterConfig) && (
					<Form.Item>
						{form.getFieldDecorator('isCapex', {
							initialValue: isCapex,
						})(
							<OWRadioGroup
								valueAccessor={(item) => item.value}
								renderRecord={(item) => item.label}
								items={capExFieldItems}
								info={[
									{
										title: 'Repair and Maintenance (R&M)',
										description: 'Costs associated with repair and maintenance of existing assets',
									},
									{
										title: 'Capital Expenditures (CapEx)',
										description:
											'Costs associated with buying new assets or upgrading existing assets',
									},
								]}
							/>
						)}
					</Form.Item>
				)}
				{nullSafeGet('isPM', filterConfig) && (
					<Form.Item>
						{form.getFieldDecorator('isPM', {
							initialValue: isPM,
						})(
							<OWRadioGroup
								valueAccessor={(item) => item.value}
								renderRecord={(item) => item.label}
								items={plannedFieldItems}
								info={[
									{
										title: 'Planned',
										description: `Scheduled maintenance work generated based on planned maintenance system.`,
									},
									{
										title: 'Reactive',
										description: `On demand maintenance work requested by your team or suggested by a service provider.`,
									},
								]}
							/>
						)}
					</Form.Item>
				)}
				{nullSafeGet('workCreatedAt', filterConfig) && (
					<Form.Item label="Work Created Between">
						{form.getFieldDecorator('workCreatedBetweenStartAndEndDates', {
							rules: [
								{
									type: 'array',
								},
							],
							initialValue:
								workCreatedAtStartDate && workCreatedAtEndDate
									? [moment(workCreatedAtStartDate), moment(workCreatedAtEndDate)]
									: undefined,
						})(
							<OWDatePicker
								key={
									workCreatedAtStartDate && workCreatedAtEndDate
										? workCreatedAtStartDate.format('YYMMDD') +
										  workCreatedAtEndDate.format('YYMMDD')
										: undefined
								}
								ranges={getDefaultDateRanges()}
								format={RANGE_PICKER_DATE_FORMAT}
								showTime={false}
							/>
						)}
					</Form.Item>
				)}
				{nullSafeGet('workCompletedAt', filterConfig) && (
					<Form.Item label="Work Completed Between">
						{form.getFieldDecorator('workCompletedBetweenStartAndEndDates', {
							rules: [
								{
									type: 'array',
								},
							],
							initialValue:
								workCompletedAtStartDate && workCompletedAtEndDate
									? [moment(workCompletedAtStartDate), moment(workCompletedAtEndDate)]
									: undefined,
						})(
							<OWDatePicker
								key={
									workCompletedAtStartDate && workCompletedAtEndDate
										? workCompletedAtStartDate.format('YYMMDD') +
										  workCompletedAtEndDate.format('YYMMDD')
										: undefined
								}
								ranges={getDefaultDateRanges()}
								format={RANGE_PICKER_DATE_FORMAT}
								showTime={false}
							/>
						)}
					</Form.Item>
				)}
				<Form.Item>
					<Button type="primary" htmlType="submit">
						Update filters
					</Button>
					<Button onClick={this.handleCancel} style={{ marginLeft: 16 }}>
						Cancel
					</Button>
				</Form.Item>
			</Form>
		);

		return (
			<div
				style={{
					width: '100%',
				}}
			>
				<div className="flex flex-row items-center justify-between">
					<div className="flex flex-row items-center">
						{showSearch && (
							<Input.Search
								placeholder={searchPlaceholder || 'Search Problem type'}
								value={search}
								style={{ width: 180 }}
								className="mr-2"
								onChange={onSearch}
							/>
						)}
						<Button
							size="large"
							icon={<FilterOutlined />}
							onClick={() => this.setState({ editing: !this.state.editing })}
						>
							Filters
						</Button>
					</div>
					{showDownload && (
						<OWButtonWithSupplierManagedLock
							size="large"
							icon={<DownloadOutlined />}
							className="inline-block"
							onClick={onDownload}
						>
							<span className="inline-block">Export CSV</span>
						</OWButtonWithSupplierManagedLock>
					)}
				</div>
				<AnalyticsSelectedFilters
					filterValues={this.getFilterValues()}
					filterConfig={[
						{
							label: hasAccessToAllLocations ? 'Location' : 'Assigned Location',
							fieldName: 'locationIds',
							stateSlice: locations,
							valueAccessor: (loc) => loc.id,
							renderItem: (loc) => loc.name,
							pillMandatory: true,
						},
						{
							label: 'Supplier',
							fieldName: 'supplierFacilityIds',
							stateSlice: supplierFacilities,
							valueAccessor: (sf) => sf.id,
							renderItem: (sf) => sf.name,
							pillMandatory: false,
						},
						{
							label: 'Problem Type',
							fieldName: 'problemTypeIds',
							stateSlice: problemTypes,
							valueAccessor: (pt) => pt.id,
							renderItem: (pt) => pt.name,
						},
						{
							label: 'Work Order Priority',
							fieldName: 'woPriorityIds',
							stateSlice: workOrderPriorities,
							valueAccessor: (pt) => pt.id,
							renderItem: (pt) => pt.name,
							pillMandatory: false,
						},
						{
							label: 'Brand',
							fieldName: 'brandIds',
							stateSlice: brands,
							valueAccessor: (b) => b.id,
							renderItem: (b) => b.brandName,
						},
						{
							fieldName: 'isCapex',
							type: FILTER_FIELD_TYPE.RADIO_GROUP,
							valueAccessor: (item) => item.value,
							renderRecord: (item) => item.label,
							items: capExFieldItems,
						},
						{
							fieldName: 'isPM',
							type: FILTER_FIELD_TYPE.RADIO_GROUP,
							valueAccessor: (item) => item.value,
							renderRecord: (item) => item.label,
							items: plannedFieldItems,
						},
						{
							label: dateRangeLabelString,
							fieldName: 'default',
							type: FILTER_FIELD_TYPE.DATE_RANGE,
							mandatory: true,
							renderRecord: (item) => item,
							valueAccessor: (item) => item,
						},
						{
							label: 'Work Created Between',
							fieldName: 'workCreatedAt',
							type: FILTER_FIELD_TYPE.DATE_RANGE,
							renderRecord: (item) => item,
							valueAccessor: (item) => item,
						},
						{
							label: 'Work Completed Between',
							fieldName: 'workCompletedAt',
							type: FILTER_FIELD_TYPE.DATE_RANGE,
							renderRecord: (item) => item,
							valueAccessor: (item) => item,
						},
					]}
					updateFilters={this.updateFiltersFromDisplay}
					openFilters={this.openDrawer}
				/>
				<Drawer closable={false} width={800} visible={editing}>
					{FilterControls}
				</Drawer>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	currentUser: state.session.currentUser,
	locations: state.locations,
	supplierFacilities: state.supplier_facilities,
	updateFilters: ownProps.updateFilters,
	clearFilters: ownProps.clearFilters,
	startDate: ownProps.startDate,
	endDate: ownProps.endDate,
	locationIds: ownProps.locationIds,
	supplierFacilityIds: ownProps.supplierFacilityIds,
	workOrderPriorities: state.work_order_priorities,
	problemTypes: state.problem_types,
	brands: state.brands,
	state: state,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	fetchMultipleLocations: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? locationsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: locationsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchMultipleSupplierFacilities: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? supplierFacilitiesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchSupplierFacilitiesIfEverInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? fetchSupplierFacilitiesIfEverInPrivateNetworkForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: fetchSupplierFacilitiesIfEverInPrivateNetworkForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		),
	fetchProblemTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		return dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? problemTypesHeirarchicalForSupplier(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
				: problemTypesHeirarchicalForBuyer(
						params,
						targetCollectionName,
						pagination,
						sorting,
						filters,
						addToTargetCollection
				  )
		);
	},
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrderPrioritiesRestCrudThunksForSupplier
				: workOrderPrioritiesRestCrudThunksForBuyer;
		return dispatch(
			fnToCall.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);
	},
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.read
				: brandsRestCrudThunksForBuyer.read;
		return dispatch(
			fnToCall(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection)
		);
	},
	fetchMultipleBrands: (ids, targetCollectionName) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)
				: brandsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchBrandsCount: (params) => {
		const fnToCall =
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.countBy
				: brandsRestCrudThunksForBuyer.countBy;
		return dispatch(fnToCall(params, 'all'));
	},
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(AnalyticsControlBar)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
